import React, { Component } from "react";
import "./Login.css";
import { API, Auth } from "aws-amplify";
import Alert from "react-bootstrap/lib/Alert";
import { Link } from "react-router-dom";
import LoaderButton from "../components/LoaderButton";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import FacebookButton from "../components/FacebookButton";
import config from "../config";
import { toast } from "react-toastify";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.getGoogleContacts.bind(this);
    this.getGoogleContactsAsync.bind(this);
    this.state = {
      isLoading: false,
      email: "",
      password: "",
      errorMessage: null,
      authToken: null
    };
  }

  initGapi() {
    // init the Google SDK client
    const g = window.gapi;
    g.load("auth2", function() {
      g.auth2.init({
        client_id: config.social.GOOGLE_APPID,
        // authorized scopes
        scope: "profile email openid"
      });
    });
  }
  loadGoogle() {
    // load the Google SDK
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;
    script.onload = this.initGapi;
    document.body.appendChild(script);
  }
  async componentDidMount() {
    const ga =
      window.gapi && window.gapi.auth2
        ? window.gapi.auth2.getAuthInstance()
        : null;
    if (!ga) this.loadGoogle();
  }

  handleFbLogin = async e => {
    console.log("handleFBlogin", e);
    console.log(
      "Auth.currentAuthenticatedUser()",
      Auth.currentAuthenticatedUser()
    );
    this.setState({ isLoading: false });
    if (e.error === undefined) {
      console.log("handleFBlogin", e);
      this.props.userHasAuthenticated(true);
    } else this.setState({ errorMessage: { message: e.error } });
  };

  handleLoginError = e => {
    console.log("handleloginError", e);
    this.setState({ isLoading: false });
    if (e.message !== undefined) {
      this.props.userHasAuthenticated(false);
      this.setState({ errorMessage: e });
    }
  };

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = async event => {
    console.log("handleSubmit");
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      console.log("login");
      const user = await Auth.signIn(this.state.email, this.state.password);
      this.props.userHasAuthenticated(true);
      this.props.history.push("/");
    } catch (error) {
      toast.error(
        "Error authenticating user (" + error.code + "): " + error.message
      );
      console.log(error);
      this.setState({ isLoading: false });
    }
  };

  handleGoogleLogin = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });
    console.log("handleGoogleLogin");

    try {
      const ga = window.gapi.auth2.getAuthInstance();
      ga.signIn()
        .then(googleUser => {
          console.log("Google user", googleUser);
          const {
            id_token,
            expires_at,
            access_token
          } = googleUser.getAuthResponse();
          this.setState({ authToken: access_token });
          const profile = googleUser.w3;
          console.log("Profile", profile);
          const user = {
            email: profile.getEmail(),
            name: profile.getName()
          };
          console.log("Sign in user", user);

          return Auth.federatedSignIn(
            // Initiate federated sign-in with Google identity provider
            "google",
            {
              // the JWT token
              token: id_token,
              // the expiration time
              expires_at
            },
            // a user object
            user
          ).then(() => {
            window.gapi.load("client", this.getGoogleContactsAsync);
          });

          //this.props.userHasAuthenticated(true);
          //this.props.history.push("/");
        })
        .catch(error => {
          console.log("API Friends error:", error);
          this.handleLoginError({
            message:
              "Unable to login with Google, please try again later (" +
              error.error +
              ")"
          });
        });
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
      console.log("Error handleGoogleLogin", e);
    }
  };

  getGoogleContactsAsync = async event => {
    console.log("getGoogleContacts async: ");
    return new Promise((resolve, reject) => {
      const client = require("https");
      var options = {
        host: "people.googleapis.com",
        path:
          "/v1/people/me/connections?personFields=emailAddresses&key=AIzaSyCNUQpCzEX7_ZtUpby0_UEj1IgJHse06M0",
        headers: { Authorization: "Bearer " + this.state.authToken }
      };
      console.log("request options", options);
      const request = client.get(options, response => {
        if (response.statusCode < 200 || response.statusCode > 299) {
          reject(new Error("Failed with status code: " + response.statusCode));
        }
        const body = [];
        response.on("data", chunk => body.push(chunk));
        response.on("end", () => resolve(body.join("")));
      });
      request.on("error", err => reject(err));
    });
  };
  async getGoogleContacts() {
    console.log("getGoogleContacts");

    var result = null;
    await this.getGoogleContactsAsync().then(response => {
      //console.log("Response from Google:" + response);
      result = JSON.parse(response);
      console.log("Google APIgetGoogleContactsAsync response:", result);

      //result = data;
      return result;
    });

    window.gapi.client.setApiKey(config.social.GOOGLE_APIKEY);
    var restRequest = window.gapi.client.request({
      path:
        "https://people.googleapis.com/v1/people/me/contacts?test=names,emailAddresses", //,			'params': {'sortOrder': 'LAST_NAME_ASCENDING'}
      scope: [
        "https://www.googleapis.com/auth/contacts.readonly",
        "https://www.googleapis.com/auth/contacts"
      ]
    });

    console.log("rest", restRequest);
    console.log("client init");

    window.gapi.client
      .init({
        client_id: config.social.GOOGLE_APPID,
        apiKey: config.social.GOOGLE_APIKEY,
        //discoveryDocs: ['https://people.googleapis.com/$discovery/rest?version=v1'],
        scope: [
          "https://www.googleapis.com/auth/contacts.readonly",
          "https://www.googleapis.com/auth/contacts"
        ]
        //scope:'profile'
      })
      .then(function() {
        // Executes an API request, and returns a Promise.
        // The method name `language.translations.list` comes from the API discovery.
        console.log("getGoogleContacts client init");
        /*
						return window.gapi.client.people.people.connections.list({
							requestSyncToken:false
							, pageToken:null
							, resourceName: 'people/me'
							,'requestMask.includeField': 'person.names'
							, personFields: 'emailAddresses'
						});*/
      })
      .catch(e => {
        console.log("error init:", e);
      });
  }

  handleAuthStateChange = state => {
    console.log(state);
    console.log("Auth.currentAuthenticatedUser()");
    console.log(Auth.currentAuthenticatedUser());
    console.log("Auth.currentCredentials()");
    console.log(Auth.currentCredentials());
    console.log("Auth.currentSession()");
    console.log(Auth.currentSession());

    if (state === "signedIn") {
      console.log("Auth.currentCredentials().identityId");
      var credentials = Auth.currentCredentials();
      console.log("handleAuthStateChange", credentials);
      //this.props.userHasAuthenticated(true);
      //this.props.history.push("/");
    }
  };

  responseFacebook(response) {
    console.log("responseFacebook");

    this.setState({ isLoading: true });

    try {
      Auth.setCredentialsFromFederation(
        "facebook",
        response.accessToken,
        response.email
      );
      //this.props.userHasAuthenticated(true);
      //this.props.history.push("/");
    } catch (e) {
      alert(e.message);
      this.setState({ isLoading: false });
    }

    console.log(response);
  }

  render() {
    return (
      <div>
        <div>
          {this.state.errorMessage && (
            <Alert
              bsSize="sm"
              dismissible="true"
              className="alert-danger"
              variant="warning"
            >
              {this.state.errorMessage.message}
              {this.state.errorMessage.link ? (
                <Link to={this.state.errorMessage.link}>
                  Click Here to continue
                </Link>
              ) : (
                ""
              )}
            </Alert>
          )}
          {this.props.location.search === "?1" && (
            <Alert
              bsSize="sm"
              dismissible="true"
              className="alert-success"
              variant="info"
            >
              Thank you for Signing Up, please login again.
            </Alert>
          )}
          <form onSubmit={this.handleSubmit}>
            <FormGroup controlId="email" bsSize="large">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                autoFocus
                type="email"
                value={this.state.email}
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup controlId="password" bsSize="large">
              <ControlLabel>Password</ControlLabel>
              <FormControl
                value={this.state.password}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <Button
              block
              bsSize="large"
              disabled={!this.validateForm()}
              type="submit"
            >
              Login
            </Button>
            {/*             
            <FacebookButton
              isLoading={this.state.isLoading}
              onLogin={this.handleFbLogin}
              onLoginError={this.handleLoginError}
            />
            <LoaderButton
              block
              bsSize="large"
              type="button"
              isLoading={this.state.isLoading}
              text="Login with Google"
              loadingText="Logging in…"
              onClick={this.handleGoogleLogin}
              className="LoginButton"
            /> */}
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js